import {
  T3,
} from 'ia-react-core';
import { Link } from 'omni-package-react-core';
import styled from 'styled-components';

export const StyledDiv = styled.div`
  width: 100%;
  margin-bottom: 24px;

`;
export const StyledLink = styled(Link)`
  font-weight: 600;
  display: table-cell;
  float: right;
  top: -19px;
  &:hover {
    text-decoration: underline;
  }
  &:active {
    color: ${({ theme }) => theme.colors.blue10};
    text-decoration: underline;
  }
`;
export const StyledTitle = styled(T3)`
  display: table-cell;
`;
